"use client";

import React from "react";
import { Phone, CircleQuestionMark } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqData = [{
  question: "Do you provide free quotes for painting projects?",
  answer: "Yes, we offer complimentary site consultations and detailed quotes for all residential and commercial projects in the Townsville and North Queensland region. Simply contact us to schedule a visit."
}, {
  question: "What areas do you service?",
  answer: "ANV Painting is based in Townsville, QLD, and we proudly serve clients throughout the entire North Queensland Region. Whether you are in the city center or surrounding suburbs, our team is ready to assist."
}, {
  question: "Do you handle both residential and commercial painting?",
  answer: "Absolutely. We have extensive experience in both sectors. From refreshing a single room in a family home to large-scale commercial repaints, our team delivers professional results tailored to the specific needs of each property."
}, {
  question: "What type of paint do you use?",
  answer: "We prioritize quality and health by using premium, low-VOC (Volatile Organic Compounds) paints. These products provide a durable, vibrant finish while being environmentally friendly and safer for your family or employees."
}, {
  question: "Is surface preparation included in your service?",
  answer: "Yes, meticulous surface preparation is the foundation of our work. We handle everything from cleaning and sanding to patching imperfections before applying any paint, ensuring a flawless and long-lasting finish."
}, {
  question: "How long will my painting project take?",
  answer: "The timeline depends on the scope of the project. During our initial consultation, we provide a clear schedule and work efficiently to meet deadlines without compromising on our high standards of craftsmanship."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="frequently-asked-questions" className="bg-background py-16 md:py-24">
      <div ref={ref} className={cn("container mx-auto max-w-3xl px-4 transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
        <div className="mb-10 text-center">
          <h2 className="text-foreground text-3xl font-bold tracking-tight sm:text-4xl">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground mt-4 text-lg">
            Find answers to common questions about our painting and decorating
            services in North Queensland.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} className="border-border/60" data-index={i}>
              <AccordionTrigger className="text-foreground text-left text-base font-semibold hover:no-underline hover:text-primary transition-colors">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-base leading-relaxed">
                {item.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>

        <div className="mt-12">
          <Alert className="bg-card border-border/50 shadow-sm">
            <Phone className="h-5 w-5 text-primary" />
            <AlertTitle className="text-foreground ml-2 text-base font-semibold">
              Still have questions?
            </AlertTitle>
            <AlertDescription className="text-muted-foreground ml-2 mt-1 text-sm">
              If you couldn't find the answer you were looking for, please don't
              hesitate to reach out. Call our Townsville office directly at{" "}
              <Link to="tel:0712345678" className="text-primary hover:underline font-medium">0409 908 999</Link>{" "}
              for personal assistance.
            </AlertDescription>
          </Alert>
        </div>
      </div>
    </section>;
}